export default {"src":"/_next/static/media/next.9099836e.svg","height":18,"width":10};